import { RefreshCw, Undo2 } from 'lucide-react'

import { Button } from '@krp/ui-kit'

import '../../../shared/uc1b/journals.css'
import { ReceiptsBrowser } from './ReceiptsBrowser'
import type { ReceiptsActions, ReceiptsVm } from '../model/types'
import './receipts.css'

/**
 * «Стандартный возврат» из РМК (RP-FB74, этап 2): поиск чека на тех же общих частях, что вкладка «Чеки» (`ReceiptsBrowser`):
 * дерево «Где смотрим», дни, фильтры и список чеков. Без выручки, итогов и графиков. Выбор чека (`actions.openReceipt`)
 * открывает окно возврата `RefundScreen` - то же, что кнопка «Вернуть» в детализации чека. Экран получает vm и actions
 * и больше ничего.
 */
export function RefundSearchScreen({ vm, actions }: { vm: ReceiptsVm; actions: ReceiptsActions }) {
  return (
    <section className="aqsi-journal" aria-labelledby="aqsi-refund-search-title">
      <header className="aqsi-journal__head">
        <h2 id="aqsi-refund-search-title">
          <Undo2 size={18} aria-hidden="true" /> Стандартный возврат · {vm.title}
        </h2>
        <Button variant="ghost" icon={<RefreshCw size={16} aria-hidden="true" />} busy={vm.list.refreshing} onClick={actions.reload}>
          Обновить
        </Button>
      </header>
      <p className="aqsi-journal__note" role="note">
        Найдите день и чек, который возвращает покупатель, и нажмите на его номер: откроется окно возврата. Позиции, цены, НДС и
        способ оплаты берутся из сохранённой копии чека.
      </p>
      <ReceiptsBrowser
        vm={vm}
        actions={actions}
        multiDayText="Чеки показываются за один день. Чтобы увидеть чеки, выберите день: в списке дней ниже или на календаре."
      />
    </section>
  )
}
